import React, { useState, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, ChevronDown, Phone } from 'lucide-react'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false)
  const dropdownTimeoutRef = useRef(null)
  const location = useLocation()

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`
      return
    }

    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const handleHomeLink = () => {
    if (location.pathname !== '/') {
      // Navigate to home page
      return
    }
    // If already on home page, scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleDropdownMouseEnter = () => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current)
      dropdownTimeoutRef.current = null
    }
    setIsServicesDropdownOpen(true)
  }

  const handleDropdownMouseLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setIsServicesDropdownOpen(false)
    }, 200)
  }

  const handleDropdownClick = (e) => {
    e.preventDefault()
    setIsServicesDropdownOpen(!isServicesDropdownOpen)
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current)
      dropdownTimeoutRef.current = null
    }
  }

  return (
    <header className="header-glass">
      <div className="container">
        <div className="header-content-premium">
          {/* Logo Section */}
          <div className="header-logo-premium">
            <Link to="/" onClick={handleHomeLink}>
              <div className="logo-wrapper">
                <img src="/logo/logo blanc.png" alt="CDGP Logo" className="logo-icon-premium" />
                <div className="logo-text">
                  <h1>Clinique du Grand Paris</h1>
                  <span className="logo-subtitle">L'Excellence Capillaire</span>
                </div>
              </div>
            </Link>
          </div>

          {/* Navigation Section */}
          <nav className="header-nav-premium">
            <ul className="nav-links-premium">
              <li>
                <Link to="/" onClick={handleHomeLink} className="nav-link-item">Accueil</Link>
              </li>
              <li className="dropdown-premium"
                onMouseEnter={handleDropdownMouseEnter}
                onMouseLeave={handleDropdownMouseLeave}>
                <a href="#services" onClick={handleDropdownClick} className="nav-link-item">
                  Services <ChevronDown size={16} className="chevron-icon" />
                </a>
                {isServicesDropdownOpen && (
                  <ul className="dropdown-menu-premium"
                    onMouseEnter={handleDropdownMouseEnter}
                    onMouseLeave={handleDropdownMouseLeave}>
                    <li><Link to="/saphori-vs-dhi-paris" onClick={() => setIsServicesDropdownOpen(false)}>SAPHORÏ® vs DHI</Link></li>
                    <li><Link to="/prix-greffe-cheveux-techniques-comparees" onClick={() => setIsServicesDropdownOpen(false)}>Prix & Comparatifs</Link></li>
                    <li><Link to="/3-techniques-vs-1-seule-methode" onClick={() => setIsServicesDropdownOpen(false)}>Nos 3 Techniques</Link></li>
                  </ul>
                )}
              </li>
              <li><a href="#galerie" onClick={(e) => { e.preventDefault(); scrollToSection('resultats'); }} className="nav-link-item">Galerie</a></li>
              <li><a href="#equipe" onClick={(e) => { e.preventDefault(); scrollToSection('equipe'); }} className="nav-link-item">Équipe</a></li>
              <li><a href="#temoignages" onClick={(e) => { e.preventDefault(); scrollToSection('temoignages'); }} className="nav-link-item">Témoignages</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="nav-link-item">Contact</a></li>
            </ul>
          </nav>

          {/* CTA Section */}
          <div className="header-cta-premium">
            <a href="tel:0148662035" className="phone-link-premium">
              <div className="phone-icon-wrapper">
                <Phone size={16} />
              </div>
              <span>01 48 66 20 35</span>
            </a>
            <a
              href="https://www.doctolib.fr/centre-laser-et-esthetique/paris/clinique-du-grand-paris"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-consultation-premium"
            >
              <span className="btn-text">Consultation Gratuite</span>
              <div className="btn-glow"></div>
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="mobile-menu-toggle-premium"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        {isMenuOpen && (
          <div className="mobile-menu-overlay">
            <nav className="mobile-nav">
              <Link to="/" onClick={() => { handleHomeLink(); setIsMenuOpen(false); }}>Accueil</Link>
              <a href="#services" onClick={() => { setIsMenuOpen(false); scrollToSection('services'); }}>Services</a>
              <a href="#galerie" onClick={() => { setIsMenuOpen(false); scrollToSection('resultats'); }}>Galerie</a>
              <a href="#equipe" onClick={() => { setIsMenuOpen(false); scrollToSection('equipe'); }}>Équipe</a>
              <a href="#temoignages" onClick={() => { setIsMenuOpen(false); scrollToSection('temoignages'); }}>Témoignages</a>
              <a href="#contact" onClick={() => { setIsMenuOpen(false); scrollToSection('contact'); }}>Contact</a>
              <div className="mobile-cta-container">
                <a
                  href="https://www.doctolib.fr/centre-laser-et-esthetique/paris/clinique-du-grand-paris"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-consultation-premium mobile"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Consultation Gratuite
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header